<page-headline
    [linkTitle]="pageHeadline.linkTitle"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<main-filters (filtersOutput)="applyNewFilters($event)"></main-filters>

<div class="">
    <div class="">
        <div class="layout-padding-bottom__1rem">
            <div class="menu-area">
                <div class="displayopt-layout">
                    <display-options
                        (displayOptionsOutput)="applyDisplayOptions($event)"
                        [showCompareToDate]="false"
                        [syncAsOfDateInf]="syncAsOfDateInf"
                    >
                    </display-options>
                </div>
                <div class="displayopt-layout">
                    <action-panel
                        [showExportCsv]="false"
                        [showSaveAsPdf]="true"
                        [showPrint]="false"
                        [title]="pageHeadline.pageTitle"
                    >
                    </action-panel>
                </div>
            </div>
        </div>
        <div class="row-layout-track">
            <div *ngFor="let lTable of leaderTables" class="largecard-layout-box__50">
                <performance-insight-ranking-table
                    [navigationParams]="lTable.navigationParams"
                    [dataMappingProperties]="lTable.dataMappingProperties"
                    [dataProperties]="lTable.dataProperties"
                >
                </performance-insight-ranking-table>
            </div>
        </div>
    </div>
</div>
